import Utils from './utils';
import InfoVM from './info-vm';
import ContentVM from './content-vm';
import ResourcesVM from './resources-vm';
import CourseworkVM from './coursework-vm';
import PublishPanelVM from './publish-panel-vm';
import WizardPage from 'libs/wizard-page';
import WizardStepNav from 'libs/wizard-step-nav';

var Wiz = {};

Wiz.InfoPage = function() { this.init.apply(this, arguments); };
Wiz.InfoPage.prototype = Kadenze.Util.extendClass(WizardPage, {
  id: 'js-session-step-1',
  name: Kadenze.I18n.t('session.steps.session_info'),
  icon: 'kf-info',
  observables: ['adaptive', 'title', 'order', 'description', 'logo', 'logo_path', 'logo_file_name', 'logo_file_size', 'remove_logo', 'forum_settings'],

  init: function(wizard) {
    this.localData = Utils.extractData(wizard.data, this.observables);
    this.viewModel = new InfoVM(this.localData, wizard);
  }
});

Wiz.ContentPage = function() { this.init.apply(this, arguments); };
Wiz.ContentPage.prototype = Kadenze.Util.extendClass(WizardPage, {
  id: 'js-session-step-2',
  name: Kadenze.I18n.t('session.steps.session_content'),
  icon: 'kf-video-generic',
  observables: ['content', 'lecture_media', 'languages', 'document_conversion_jobs', 'document_conversion_job_ids', 'upload_access'],

  init: function(wizard) {
    this.localData = Utils.extractData(wizard.data, this.observables);
    this.viewModel = new ContentVM(this.localData, wizard);
  },
});

Wiz.ResourcesPage = function() { this.init.apply(this, arguments); };
Wiz.ResourcesPage.prototype = Kadenze.Util.extendClass(WizardPage, {
  id: 'js-session-step-3',
  name: Kadenze.I18n.t('session.steps.session_resources'),
  icon: 'kf-link',
  observables: ['existing_resources', 'resources', 'resource_template', 'resource_ids'],

  init: function(wizard) {
    this.localData = Utils.extractData(wizard.data, this.observables);
    this.viewModel = new ResourcesVM(this.localData, wizard);
  }
});

Wiz.CourseworkPage = function() { this.init.apply(this, arguments); };
Wiz.CourseworkPage.prototype = Kadenze.Util.extendClass(WizardPage, {
  id: 'js-session-step-4',
  name: `Session ${Kadenze.I18n.n('Coursework')}`,
  icon: 'kf-coursework',
  observables: ['adaptive', 'existing_coursework', 'course_coursework', 'coursework_ids'],

  init: function(wizard) {
    this.localData = Utils.extractData(wizard.data, this.observables);
    this.viewModel = new CourseworkVM(this.localData, wizard);
  }
});

Wiz.Wizard = function() {
  var self = this;

  self.data = JSON.parse($('#session_json').val());
  self.$el = $('#session');
  self.$nextBtn = $('.js-wizard-next');
  self.$prevBtn = $('.js-wizard-prev');
  self.$steps = $('.js-wizard-step');
  self.PAGES = [];
  self.curPageIndex = 0;
  self.validationOptions = _.extend(Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS, { insertMessages: false });
  self.isEditing = self.data.id ? true : false;

  /*---------------------------------------- PAGE NAV FUNCTIONS ----------------------------------------------------*/

  self.init = function() {
    console.log('Initializing SessionWizard');

    self.PAGES = [
      new Wiz.InfoPage(self),
      new Wiz.ContentPage(self),
      new Wiz.ResourcesPage(self),
      new Wiz.CourseworkPage(self)
    ];


    self.publishPanel = new PublishPanelVM(self.data, self);

    self.publishPanel.summaries([]);

    ko.applyBindingsWithValidation(self, self.$el[0], self.validationOptions);

    var stepObj = {
      numVisible: 1,
      pages: self.PAGES,
      breakpoints: {
        xs: 1,
        sm: 2,
        lg: 3
      }
    };

      //Init progress bar AFTER ko binds with the DOM so it can get the accurate step count
    self.stepProgress = new WizardStepNav($('#js-wizardNav'), self, stepObj);

    if(self.isEditing) {
      self.populateEntireSummary();
      self.curPageIndex = 0;
      self.publishPanel.isLastPage(self.isLastPage());
    }

    self.showPageByIndex(self.curPageIndex);

    self.delegateEvents();

    setTimeout(function() {
      (new Kadenze.KdForms()).update();
    }, 200);
  };

  self.delegateEvents = function() {
    self.$nextBtn.on('click', $.proxy(self.onNextClick, self));
    self.$prevBtn.on('click', $.proxy(self.onPreviousClick, self));
  };

  self.showPageByIndex = function(index) {
    self.showPage(self.PAGES[index]);
  };

  self.showPage = function(pageObj) {
    var $page = $('#' + pageObj.id),
      lastPage = self.PAGES[self.curPageIndex - 1];

    self.curPageIndex = self.PAGES.indexOf(pageObj);

    self.$steps.stop(true, true).hide(); // hide all subpages
    $page.stop(true, true).fadeIn(); // show subpage by pageID

    self.stepProgress.setActiveStepByIndex(self.curPageIndex);
    self.updatePublishPanelSummary(lastPage);

    // Notify the publish panel our page has changed
    self.publishPanel.isLastPage(self.isLastPage());

    if (!pageObj.viewModel.initialized) {
      pageObj.viewModel.initUI();
    }
  };

  self.onNextClick = function(e) {
    e.preventDefault();

    var curPage = self.PAGES[self.curPageIndex],
      pageIsValid = self.validatePageClientSide(curPage);

    if(pageIsValid) {
      self.updatePage(curPage);
    }
  };

  self.updatePage = function(page) {
    var data = self.getAllData(),
      request = page.viewModel.createOrUpdate(data);

    request.done(self.nextPage);
  };

  self.validatePageClientSide = function(page) {
    var errors = page.viewModel.validate();
    if(errors.length) {
      new Kadenze.Notice.error({ message: errors });
      return false;
    } else {
      return true;
    }
  };

  self.onPreviousClick = function(e) {
    e.preventDefault();
    self.previousPage();
  };

  self.isFirstPage = function() {
    return (self.curPageIndex === 0);
  };

  self.isLastPage = function() {
    return (self.curPageIndex + 1) === self.PAGES.length;
  };


  self.nextPage = function() {
    if (!self.isLastPage()) {
      self.curPageIndex++;
      while(!self.PAGES[self.curPageIndex].isEnabled()) {
        self.curPageIndex++;
      }
      self.showPageByIndex(self.curPageIndex);
    }
  };

  self.previousPage = function() {
    if (!self.isFirstPage()) {
      self.curPageIndex--;
      while(!self.PAGES[self.curPageIndex].isEnabled()) {
        self.curPageIndex--;
      }
      self.showPageByIndex(self.curPageIndex);
    }
  };

  self.updatePublishPanelSummary = function(page) {
    if(!page) return;

    var existing, newSummary = page.viewModel.getSummary();

    if(newSummary) {
      existing = _.find(self.publishPanel.summaries(), function(summary) { return summary.id === newSummary.id; });

      if(existing) {
        self.publishPanel.summaries.replace(existing, newSummary);
      } else {
        self.publishPanel.summaries.push(newSummary);

        if(!self.isEditing) {
          // Kinda hacky way to collapse all other summary sections
          $('.js-summary.active').not('#summary-' + newSummary.id).find('a').trigger('click');
        }
      }
    }
  };

  self.populateEntireSummary = function() {
    _.each(self.PAGES, function(page) {
      self.updatePublishPanelSummary(page);
    });
  };

  self.determineLastActivePage = function() {
    var lastActivePage = 0;

    _.each(self.PAGES, function(page, index) {
      if(page.viewModel.hasData && page.viewModel.hasData())
        lastActivePage = index;
    });

    self.stepProgress.setActiveStepByIndex(lastActivePage);
    return lastActivePage;
  };

  this.dispatchBindingCallbacks = session => {
    this.PAGES.forEach(page => {
      if (page.viewModel.reBind)
        page.viewModel.reBind(session);
    });

    if (this.publishPanel.reBind)
      this.publishPanel.reBind(session);
  };

  self.getAllData = function() {
    var pagesData, publishPanelData;

    pagesData = _.chain(self.PAGES)
      .map(function(page) { if(page.viewModel) return page.viewModel.renderData(); })
      .compact()
      .zipObjects()
      .value();

    publishPanelData = self.publishPanel.renderData();

    return _.zipObjects([pagesData, publishPanelData]);
  };

  return self;

}; // End Wiz.Wizard

export default {
  init: function (node) {
    var wizard = new Wiz.Wizard();
    wizard.init();
  }
};


